import { create } from 'zustand';

export const useFeedbackStore = create<{ error: string | null; dismiss: () => void }>((set) => ({
  error: null,
  dismiss: () => set({ error: null }),
}));
export function reportError(error: unknown): void {
  useFeedbackStore.setState({ error: error instanceof Error ? error.message : String(error) });
}
/** Catch UI action failures while retaining the last persisted data. */
export async function runUiAction<T>(action: () => Promise<T>): Promise<T | undefined> {
  try { return await action(); } catch (error) { reportError(error); }
}
